import React, {Component} from "react";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import {Col, ControlLabel, FormControl, Grid, Row} from "react-bootstrap";
import ReactNotify from "react-notify";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import KartyTable from "./components/KartyTable";
import KartyService from "./KartyService";
import KartyForm from "./components/KartyForm";
import TrasyService from "../../konfiguracja/trasyConfig/trasy/TrasyService";
import {TopButtonAdd} from "../../../componentsTopsa/buttons/TopButtons";
import LSService from "../../../utilities/localStorageService/LSService";
import {TopAlertInformacja} from "../../../componentsTopsa/alerty/TopAlerts";
import TopIf from "../../../componentsTopsa/if/TopIf";
import {TopSelect} from "../../../componentsTopsa/selects/TopSelects";
import ScrollUtilities from "../../../utilities/ScrollUtilities";

export default class KartyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            karty: [],
            klienci: [],
            trasy: [],
            pokazFormularz: false,
            edytowana: null,
            klientDoDodawania: null,
            strona: 1,
            ilosc: 15,
            pageable: {
                first: false,
                last: false,
                page: 0,
                size: 0,
                totalElements: 0,
                totalPages: 0,
            },
            szukanyCiag: '',
            trwaGenerowanie: false,

            trasaDoWyszukania:null,

            statusDoWyszukania: {value: '', label: 'wszystkie'},
            statusyDoWyszukania: [
                {value: '', label: 'wszystkie'},
                {value: 'NOWA', label: 'nowa'},
                {value: 'PRZYJETA', label: 'przyjeta'},
                {value: 'GOTOWA', label: 'gotowa'},
                {value: 'ZWROCONA', label: 'zwrócona'}
            ]
        };
        this.zamknijFormularz = this.zamknijFormularz.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)
        this.onChangeSearchfield = this.onChangeSearchfield.bind(this)
        this.onSizePerPageList = this.onSizePerPageList.bind(this)
        this.onPageChange = this.onPageChange.bind(this)
        this.onChangeStatusDoWyszukania = this.onChangeStatusDoWyszukania.bind(this)
    }

    componentDidMount() {
        this.pobierzKarty()
        this.pobierzTrasy()

        if (Boolean(LSService.pobierzKarteDoEdycji())) {
            this.setState({
                edytowana: LSService.pobierzKarteDoEdycji(),
                pokazFormularz: true
            })
            LSService.usunKarteDoEdycji()
        }

        if (Boolean(LSService.pobierzDaneKlientaDoDodaniaKarty())) {
            this.setState({
                klientDoDodawania: LSService.pobierzDaneKlientaDoDodaniaKarty(),
                pokazFormularz: true
            })
            LSService.usunDaneKlientaDoDodaniaKarty()
        }

        if (Boolean(LSService.pobierzInformacjeONowoUtworzonymKliencie())) {
            this.setState({
                klientDoDodawania: LSService.pobierzInformacjeONowoUtworzonymKliencie(),
                pokazFormularz: true
            })
            LSService.usunNowoUtworzonegoKlienta()
        }
    }

    pobierzKarty(strona = this.state.strona, ilosc = this.state.ilosc, szukanyCiag = this.state.szukanyCiag, status = this.state.statusDoWyszukania, trasa = this.state.trasaDoWyszukania) {
        this.setState({trwaGenerowanie: true})
        let ciag = null;
        if (szukanyCiag.length > 2) {
            ciag = szukanyCiag
        }

        KartyService.getKartyPageable((strona - 1), ilosc, ciag, status.value, (trasa)?trasa.idTr:'').then(function (response) {
            if (response) {

                let arr = Array.from(response.data.content, item => {
                    return {
                        ...item,
                        klient: item.imieKl + ' ' + item.nazKl
                    }
                })

                this.setState({
                    karty: arr,
                    pageable: {
                        first: response.data.first,
                        last: response.data.last,
                        page: response.data.number,
                        size: response.data.size,
                        totalElements: response.data.totalElements,
                        totalPages: response.data.totalPages,
                    },
                    trwaGenerowanie: false
                })
            }
            else {
                console.log('Problem z pobraniem kart')
                this.setState({
                    karty: [],
                    pageable: {
                        first: false,
                        last: false,
                        page: 0,
                        size: 0,
                        totalElements: 0,
                        totalPages: 0,
                    },
                    trwaGenerowanie: false
                })
            }
        }.bind(this)).catch(function (err) {
            this.setState({trwaGenerowanie: false})
        }.bind(this))
    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {

            let arr = Array.from(response.data.content.filter(i => i.status >= 0))

            arr.sort((a, b) => {
                if (a.nazMiOd === "Rzeszów" && a.idTr < b.idTr) return -1
                else return 1
            })


            this.setState({trasy: arr})


        }.bind(this))
    }

    zamknijFormularz() {
        this.setState({
            pokazFormularz: false,
            edytowana: null,
            klientDoDodawania: null
        })
    }

    onClickZapisz(obj, czyEdycja) {
        if (czyEdycja) {
            KartyService.editKarta(this.state.edytowana.idKa, obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie edytowano kartę", "", 3000);
                    this.pobierzKarty()
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas edycji karty ", "", 3000);
                }
            }.bind(this))
            this.zamknijFormularz()
        }
        else {
            KartyService.addKarta(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie dodano kartę", "", 3000);
                    this.pobierzKarty(1, 15, '', {value: '', label: 'wszystkie'});
                    this.setState({
                        strona: 1,
                        ilosc: 15,
                        pageable: {
                            first: false,
                            last: false,
                            page: 0,
                            size: 0,
                            totalElements: 0,
                            totalPages: 0,
                        },
                        szukanyCiag: '',
                        statusDoWyszukania: {value: '', label: 'wszystkie'},
                    })
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas dodawania karty ", "", 3000);
                }
            }.bind(this))
            this.zamknijFormularz()
        }
    }

    onClickEdytuj(obj) {
        ScrollUtilities.scrollToTop()
        this.setState({
            edytowana: obj,
            pokazFormularz: true
        })
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc kartę klienta: ' + obj.klient)) {
            KartyService.deleteKarta(obj.idKa).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie usunięto kartę", "", 3000);
                    this.pobierzKarty()
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas usuwania karty ", "", 3000);
                }
            }.bind(this))
        }
    }

    onChangeStatus(status, obj) {
        let karta = obj;
        karta['status'] = status.value
        KartyService.editKarta(obj.idKa, karta).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success("Pomyślnie edytowano status karty", "", 3000);
                this.pobierzKarty()
            }
            else {
                this.refs.notificator.error("Wystąpił błąd podczas edycji statusu karty ", "", 3000);
            }
        }.bind(this))
    }

    onChangeSearchfield(e) {
        this.setState({szukanyCiag: e.target.value})
        if (e.target.value.length > 2) {
            this.pobierzKarty(this.state.strona, this.state.ilosc, e.target.value, this.state.statusDoWyszukania,this.state.trasaDoWyszukania)
        }
        else if (e.target.value.length === 0) {
            this.pobierzKarty(this.state.strona, this.state.ilosc, '', this.state.statusDoWyszukania,this.state.trasaDoWyszukania)
        }
    }

    onSizePerPageList(size) {
        this.setState({ilosc: size})
    }

    onPageChange(page, sizePerPage) {
        this.setState({strona: page})
        this.pobierzKarty(page, sizePerPage, this.state.szukanyCiag, this.state.statusDoWyszukania)
    }

    onChangeStatusDoWyszukania(e) {
        this.setState({
            statusDoWyszukania: e
        })
        this.pobierzKarty(this.state.strona, this.state.ilosc, this.state.szukanyCiag, e)
    }

    onChangeTrasaDoWyszukania(e){
        this.setState({trasaDoWyszukania:e});
        this.pobierzKarty(this.state.strona, this.state.ilosc, this.state.szukanyCiag, this.state.statusDoWyszukania, e)
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'ZarzadzanieBiletamiContainer'}>
                    <TopIf isTrue={this.state.trwaGenerowanie}>
                        <div id={'GenerowanieContainer'}>
                            <h1>
                                <i className={'fa fa-spinner fa-spin'}></i>
                                <div>
                                    Trwa szukanie rekordów...
                                </div>
                                <h6>
                                    Proces ten może potrwać dłuższą chwilę
                                </h6>
                            </h1>
                        </div>
                    </TopIf>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[
                                    {addressUrl: '/konfiguracja', text: 'Konfiguracja'},
                                    {addressUrl: '/konfiguracja/zarzadzanie-klientami', text: 'Zarządzanie klientami'},
                                    {addressUrl: '/konfiguracja/zarzadzanie-klientami/karty', text: 'Karty'},
                                ]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12} lg={3}>
                            <ControlLabel>Wyszukaj po nazwisku bądź po nr karty:</ControlLabel>
                            <FormControl onChange={this.onChangeSearchfield} placeholder={'Nazwisko lub nr karty (min 3 znaki)'}/>
                            <TopAlertInformacja text={'Minimum 3 znaki, automatyczne szukanie'}/>
                        </Col>
                        <Col xs={12} lg={2}>
                            <ControlLabel>Wyszukaj po statusie:</ControlLabel>
                            <TopSelect onChange={this.onChangeStatusDoWyszukania}
                                       value={this.state.statusDoWyszukania}
                                       options={this.state.statusyDoWyszukania}
                                       clearable={false}
                            />
                        </Col>
                        <Col xs={12} lg={2}>
                            <ControlLabel>Wyszukaj po trasie:</ControlLabel>
                            <TopSelect onChange={(e)=>this.onChangeTrasaDoWyszukania(e)}
                                       value={this.state.trasaDoWyszukania}
                                       options={this.state.trasy}
                                       valueKey={"idTr"}
                                       labelKey={"nazTr"}
                                       clearable={true}
                            />
                        </Col>
                        <Col xs={12} lg={5}>
                            {
                                !Boolean(this.state.pokazFormularz) ?
                                    <div className={'pull-right'} style={{marginTop: '20px'}}>
                                        <TopButtonAdd onClick={() => {
                                            this.setState({pokazFormularz: true});
                                            ScrollUtilities.scrollToTop()
                                        }}/>
                                    </div>
                                    :
                                    ''

                            }
                        </Col><Col xs={12}>
                        {
                            !Boolean(this.state.pokazFormularz) ?
                                ''
                                :
                                <KartyForm trasy={this.state.trasy}
                                           handleClickAnuluj={this.zamknijFormularz}
                                           handleClickZapisz={this.onClickZapisz}
                                           edytowana={this.state.edytowana}
                                           klientDoDodawania={this.state.klientDoDodawania}
                                />

                        }
                    </Col>
                        <Col xs={12}>
                            <KartyTable data={this.state.karty}
                                        handleEdytuj={this.onClickEdytuj}
                                        handleUsun={this.onClickUsun}
                                        handleChangeStatus={this.onChangeStatus}
                                        history={this.props.history}
                                        pageable={this.state.pageable}
                                        ilosc={this.state.ilosc}
                                        strona={this.state.strona}
                                        onSizePerPageList={this.onSizePerPageList}
                                        onPageChange={this.onPageChange}
                                        czySzukanyCiag={this.state.szukanyCiag.length > 2}
                            />
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/klienciConfig/karty/KartyContainer.js